import React, { useContext, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import {
  Col,
  Container,
  Row,
  Form,
  Input,
  Label,
  Card,
  CardBody,
  Button,
  FormFeedback,
  CardTitle,
} from "reactstrap"
import * as Yup from "yup"
import Select from "react-select"
import { useFormik } from "formik"
import { classApi } from "apis/ClassListApi"
import { classGroupApi } from "apis/ClassGroupApi"
import Swal from "sweetalert2"
import { CircularApi } from "apis/CircularAPI"
import config from "config/config"
import { SessionContext } from "context/sessionContext"
import Loading from "components/Loading"

const EditCircular = props => {
  document.title = "Edit Circular"
  const [user, setUserLogged] = useState(
    JSON.parse(localStorage.getItem("User"))
  )
  const [circular, setCircular] = useState([])
  const [classList, setClassList] = useState([])
  const [AllClassGroup, setAllClassGroup] = useState([])
  const [loading, setloading] = useState(false)
  const { Session } = useContext(SessionContext)
  let session = Session || sessionStorage.getItem("SessionId")
  const { id } = useParams()

  const MAX_FILE_SIZE = 5 * 1024 * 1024 // 5 MB in bytes

  // validation
  const validation = useFormik({
    enableReinitialize: true, // Keep this true for edit page to load initial data

    initialValues: {
      title: "",
      description: "",
      st_class: [],
      send_by: [],
      notice_file: "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Please Enter Your Title"),
      st_class: Yup.array().min(1, "Please Enter Your Class"),
      send_by: Yup.array().min(1, "This is required"),
      notice_file: Yup.mixed()
        .test(
          "fileSize",
          "File size exceeds the limit of 5 MB.",
          value => !value || value.size <= MAX_FILE_SIZE
        )
        .notRequired(),
    }),
    onSubmit: values => {
      setloading(true)
      const data = new FormData()
      data.append("notice_file", values.notice_file)
      data.append("title", values.title)
      data.append("description", values.description)
      if (user === "Admin") {
        // send array of class group ids
        data.append("groupofclass_ids", JSON.stringify(values.st_class || []))
        // also expand groups to send individual classes
        const classes = []
        ;(values.st_class || []).forEach(groupId => {
          const group = AllClassGroup.find(g => g.value === groupId)
          if (group && group.st_class) {
            try {
              const groupClasses = JSON.parse(group.st_class)
              groupClasses.forEach(c => classes.push(c))
            } catch (e) {
              // ignore
            }
          }
        })
        data.append("st_class", JSON.stringify(classes))
      } else {
        data.append("st_class", JSON.stringify(values.st_class))
      }
      data.append("send_by", JSON.stringify(values.send_by))
      data.append("circular_id", id)
      data.append("session_id", session)
      CircularApi.updateCircular(data)
        .then(res => {
          if (res.data.status === 200) {
            setloading(false)
            Swal.fire({
              text: res.data.msg,
              icon: "success",
              imageAlt: "success image",
            }).then(result => {
              if (result.isConfirmed) {
                window.location.href = "/circular"
              }
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
  })

  let cid = {
    circular_id: id,
  }

  useEffect(() => {
    CircularApi.getSingleCircular(cid)
      .then(res => {
        const circularData = res.data.circular[0]
        setCircular(circularData)

        // Set Formik values directly
        validation.setFieldValue("title", circularData.title)
        validation.setFieldValue("description", circularData.description)
        // If circular was created using class groups, prefer those ids
        if (
          circularData.groupofclass_ids &&
          Array.isArray(circularData.groupofclass_ids)
        ) {
          validation.setFieldValue("st_class", circularData.groupofclass_ids)
        } else if (circularData.st_class) {
          validation.setFieldValue(
            "st_class",
            JSON.parse(circularData.st_class)
          )
        }
        validation.setFieldValue(
          "send_by",
          circularData.send_by ? JSON.parse(circularData.send_by) : []
        )
      })
      .catch(err => {
        console.log(err)
      })
  }, [id])

  useEffect(() => {
    classApi
      .getAllClass()
      .then(res => {
        setClassList(res.data.section_list)
      })
      .catch(err => {
        console.log(err)
      })
    // load class groups for admin
    classGroupApi.getClassGroup().then(res => {
      const groups = res.data?.grupofclass?.map(g => ({
        value: g.id,
        label: g.group_name,
        st_class: g.st_class,
      }))
      setAllClassGroup(groups || [])
    })
  }, [])

  const classListOption = classList?.map(cl => {
    return {
      value: cl.UID,
      label: `${cl.st_class} ${cl.st_sec}`,
    }
  })

  const SendListOption = [
    { value: 1, label: "Teacher" },
    { value: 2, label: "Student" },
    { value: 3, label: "Parent" },
  ]

  const classhandleChange = selectedOption => {
    validation.setFieldValue("st_class", selectedOption)
  }

  const handleChange = selectedOption => {
    validation.setFieldValue("send_by", selectedOption)
  }

  const formClear = () => {
    validation.resetForm()
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Circular" breadcrumbItem="Edit Circular" />
          <Row>
            <Col lg="12">
              <Card>
                {loading ? (
                  <Loading />
                ) : (
                  <CardBody>
                    <Form
                      onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      <Row>
                        <Col sm={12} lg={6}>
                          <div className="mb-2">
                            <Label htmlFor="title" className="my-control">
                              Title
                            </Label>
                            <Input
                              id="n_title"
                              name="title"
                              type="text"
                              className="form-control"
                              placeholder="Title"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.title}
                              invalid={
                                validation.touched.title &&
                                validation.errors.title
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.title &&
                            validation.errors.title ? (
                              <FormFeedback type="invalid">
                                {validation.errors.title}
                              </FormFeedback>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            {user === "Admin" ? (
                              <>
                                <Label className="control-label my-control">
                                  Class Group
                                </Label>
                                <Select
                                  name="st_class"
                                  className="basic-multi-select"
                                  classNamePrefix="select2-selection"
                                  placeholder="Select Class Group..."
                                  title="Class Group"
                                  options={AllClassGroup}
                                  isMulti
                                  value={AllClassGroup.filter(opt => {
                                    let stClass = validation.values.st_class

                                    // If stringified JSON
                                    if (typeof stClass === "string") {
                                      try {
                                        stClass = JSON.parse(stClass)
                                      } catch (e) {
                                        stClass = []
                                      }
                                    }

                                    // Ensure array
                                    if (!Array.isArray(stClass)) {
                                      stClass = []
                                    }

                                    return stClass.includes(opt.value)
                                  })}
                                  onChange={selected => {
                                    const ids = selected
                                      ? selected.map(s => s.value)
                                      : []
                                    validation.setFieldValue("st_class", ids)
                                  }}
                                  onBlur={validation.handleBlur}
                                  invalid={
                                    validation.touched.st_class &&
                                    validation.errors.st_class
                                      ? true
                                      : false
                                  }
                                />
                              </>
                            ) : (
                              <>
                                <Label className="control-label my-control">
                                  Class
                                </Label>
                                <Select
                                  name="st_class"
                                  className="basic-multi-select"
                                  classNamePrefix="select2-selection"
                                  placeholder="Select Class..."
                                  title="Class"
                                  options={classListOption}
                                  isMulti
                                  value={validation.values.st_class}
                                  onChange={classhandleChange}
                                  onBlur={validation.handleBlur}
                                  invalid={
                                    validation.touched.st_class &&
                                    validation.errors.st_class
                                      ? true
                                      : false
                                  }
                                />
                              </>
                            )}
                            {validation.touched.st_class &&
                            validation.errors.st_class ? (
                              <div
                                style={{
                                  color: "#f46a6a",
                                  fontSize: "11px",
                                  marginTop: "3px",
                                }}
                              >
                                This is required
                              </div>
                            ) : null}
                          </div>

                          <div className="mb-3">
                            <Label className="control-label my-control">
                              To send
                            </Label>
                            <Select
                              name="send_by"
                              classNamePrefix="select2-selection"
                              placeholder="Select..."
                              title="To send"
                              options={SendListOption}
                              isMulti
                              value={validation.values.send_by}
                              onChange={handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.send_by &&
                                validation.errors.send_by
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.send_by &&
                            validation.errors.send_by ? (
                              <div
                                style={{
                                  color: "#f46a6a",
                                  fontSize: "11px",
                                  marginTop: "3px",
                                }}
                              >
                                This is required
                              </div>
                            ) : null}
                          </div>
                        </Col>
                        <Col sm={12} lg={6}>
                          <div className="mb-3">
                            <Label htmlFor="Description">Description</Label>
                            <Input
                              id="n_title"
                              name="description"
                              rows="5"
                              type="textarea"
                              className="form-control"
                              placeholder="Write here your Description"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.description}
                              invalid={
                                validation.touched.description &&
                                validation.errors.description
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.description &&
                            validation.errors.description ? (
                              <FormFeedback type="invalid">
                                {validation.errors.description}
                              </FormFeedback>
                            ) : null}
                          </div>
                          <div className="mt-0">
                            <Label
                              className="control-label my-control"
                              htmlFor="input"
                            >
                              Upload Image or PDF
                            </Label>
                            <div className="input-group">
                              <Input
                                name="notice_file"
                                type="file"
                                className="form-control"
                                id="input"
                                onChange={e => {
                                  validation.setFieldValue(
                                    "notice_file",
                                    e.target.files[0]
                                  )
                                }}
                                invalid={
                                  validation.touched.notice_file &&
                                  validation.errors.notice_file
                                    ? true
                                    : false
                                }
                              />
                            </div>
                            {validation.touched.notice_file &&
                            validation.errors.notice_file ? (
                              <div
                                style={{
                                  color: "red",
                                  fontSize: "11px",
                                  marginTop: "3px",
                                }}
                              >
                                {validation.errors.notice_file}
                              </div>
                            ) : null}
                          </div>
                          <div className="position-relative my-2">
                            {circular?.notice_file && (
                              <>
                                {["jpg", "jpeg", "png"].includes(
                                  circular.notice_file
                                    .split(".")
                                    .pop()
                                    .toLowerCase()
                                ) ? (
                                  <a
                                    href={`${config.BaseImageUrl}/${circular.notice_file}`}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    className="text-muted"
                                  >
                                    <img
                                      src={`${config.BaseImageUrl}/${circular.notice_file}`}
                                      alt=""
                                      width="200"
                                    />
                                  </a>
                                ) : (
                                  <a
                                    href={`${config.BaseImageUrl}/${circular.notice_file}`}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    className="text-muted"
                                  >
                                    <div className="border p-3 text-center">
                                      <i className="mdi mdi-file-pdf-outline font-size-48 text-danger"></i>
                                      <p className="mb-0">View PDF</p>
                                    </div>
                                  </a>
                                )}

                                {circular.notice_file
                                  .split(".")
                                  .pop()
                                  .toLowerCase() === "pdf" && (
                                  <iframe
                                    src={`https://docs.google.com/viewer?url=${config.BaseImageUrl}/${circular.notice_file}&embedded=true`}
                                    height="200px"
                                    width="300"
                                  />
                                )}
                              </>
                            )}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <div className="text-end pt-2">
                            <Button
                              color="primary"
                              type="submit"
                              className="btn btn-primary waves-effect waves-light"
                            >
                              Update
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                )}
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default EditCircular
